


















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as antd from 'ant-design-vue';
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { RouterItem } from '@/utils/interfaces';

const APP_TITLE = process.env.VUE_APP_TITLE;
const a = process.env.VUE_APP_TITLE;
@Component
export default class App extends Vue {
  locale = zh_CN;

  @Watch('$route')
  onRouteChanged(route: RouterItem) {
    if (route.meta && route.meta.title) {
      document.title = route.meta.title + ' - ' + APP_TITLE;
    } else {
      document.title = APP_TITLE!;
    }
  }
  showBackTop = false;
  backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  handleScroll() {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    this.showBackTop = scrollTop > 200;
  }

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  created() {
    const browserName = navigator.userAgent.toLowerCase();
    if (/msie/i.test(browserName) && !/opera/.test(browserName)) {
      this.$warning({
        content: `您使用的浏览器版本太低，可能无法正常使用本系统。 建议使用谷歌、火狐或360浏览器极速模式进行访问。`,
        title: '提示',
      });
      return;
    } else if (/firefox/i.test(browserName)) {
      return;
    } else if (/chrome/i.test(browserName) && /webkit/i.test(browserName) && /mozilla/i.test(browserName)) {
      return;
    } else {
      this.$warning({
        content: `您使用的浏览器版本太低，可能无法正常使用本系统。 建议使用谷歌、火狐或360浏览器极速模式进行访问。`,
        title: '提示',
      });
    }
  }
}
